import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Navigation from './Navigation';
import NavBar from './Navbar';
import Breadcrumb from './Breadcrumb';

import useWindowSize from '../../hooks/useWindowSize';
import useOutsideClick from '../../hooks/useOutsideClick';

import { configActions } from './../../features/Config/ConfigSlice';
import { loaderActions } from './../../features/Loader/LoaderSlice';
import { LoadVendorsRequest } from './../../features/Vendor/VendorSlice';
import * as actionType from '../../features/Config/Types';
import { Outlet, useLocation } from 'react-router-dom';
import { AllCompanyIDs, UniqueCompanyIDs } from '../../components/shared/Company';

const AdminLayout = () => {
  const windowSize = useWindowSize();
  const ref = useRef();
  const location = useLocation();

  const { collapseMenu, layout, subLayout, headerFixedLayout } = useSelector(
    (state) => state.config
  );
  const { fetchingVendors } = useSelector((state) => state.vendor);
  const { vendors } = useSelector((state) => state.auth);
  const [hasCalledLoadVendors, setHasCalledLoadVendors] = useState(false);
  const dispatch = useDispatch();

  useOutsideClick(ref, () => {
    if (collapseMenu) {
      dispatch(configActions.update({ type: actionType.COLLAPSE_MENU }));
    }
  });

  useEffect(() => {
    if (windowSize.width > 992 && windowSize.width <= 1024 && layout !== 'horizontal') {
      dispatch(configActions.update({ type: actionType.COLLAPSE_MENU }));
    }

    if (layout === 'horizontal' && windowSize.width < 992) {
      dispatch(configActions.update({ type: actionType.CHANGE_LAYOUT, layout: 'vertical' }));
    }
  }, [dispatch, layout, windowSize]);

  const mobileOutClickHandler = () => {
    if (windowSize.width < 992 && collapseMenu) {
      dispatch(configActions.update({ type: actionType.COLLAPSE_MENU }));
    }
  };

  let mainClass = ['pcoded-wrapper'];
  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    mainClass = [...mainClass, 'container'];
  }

  let common = (
    <>
      <Navigation />
      <NavBar />
    </>
  );

  if (windowSize.width < 992) {
    let outSideClass = ['nav-outside'];
    if (collapseMenu) {
      outSideClass = [...outSideClass, 'mob-backdrop'];
    }
    if (headerFixedLayout) {
      outSideClass = [...outSideClass, 'mob-fixed'];
    }

    common = (
      <div className={outSideClass.join(' ')} ref={ref}>
        {common}
      </div>
    );
  }

  async function LoadVendors() {
    await setHasCalledLoadVendors(true);
    await dispatch(loaderActions.show());
    let companyIds = AllCompanyIDs;
    if (vendors && vendors.length > 0) {
      companyIds = UniqueCompanyIDs(vendors);
    }
    const EMMVendors = vendors.filter((v) => v.name === 'EMM');
    const DUNVendors = vendors.filter((v) => v.name === 'DUN');
    await companyIds.forEach((companyId, idx) => {
      const isEmm = companyId === process.env.REACT_APP_COMP_EMM;
      dispatch(
        LoadVendorsRequest({
          vendors: isEmm ? EMMVendors : DUNVendors,
          type: 'user_vendor',
          companyId
        })
      );
    });
    await dispatch(loaderActions.hide());
    await setHasCalledLoadVendors(false);
  }

  const allowedPaths = [
    '/',
    '/sku-breakdown',
    '/transfer-orders',
    '/purchase-orders',
    '/feedback-orders',
    '/purchase-receipts',
    '/users/management',
    '/file-management'
  ];

  const showBreadCrumb = allowedPaths.some((path) => {
    return path === location.pathname;
  });

  useEffect(() => {
    if (allowedPaths.includes(location.pathname)) {
      if (!fetchingVendors || !hasCalledLoadVendors) {
        LoadVendors();
      }
    }
  }, [location.pathname, vendors]);

  return (
    <>
      {common}
      <div className="pcoded-main-container" onClick={() => mobileOutClickHandler}>
        <div className={mainClass.join(' ')}>
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              {showBreadCrumb === true ? <Breadcrumb /> : <></>}
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLayout;
